import { render, staticRenderFns } from "./StatusPenyampaianChart.vue?vue&type=template&id=5b9c6c60&"
import script from "./StatusPenyampaianChart.vue?vue&type=script&lang=js&"
export * from "./StatusPenyampaianChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports